import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";

const LOGO_URL = "https://kargonode.com/wp-content/uploads/2026/02/logo-correo.webp";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Check for recovery token in URL hash
    const hash = window.location.hash;
    if (hash.includes("type=recovery")) {
      setReady(true);
    } else {
      setError("Enlace de recuperación inválido o expirado.");
    }
  }, []);

  const handleReset = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");

    const { error } = await supabase.auth.updateUser({ password });

    if (error) {
      setError("No se pudo actualizar la contraseña. Intenta de nuevo.");
    } else {
      setMessage("¡Contraseña actualizada exitosamente! Redirigiendo...");
      setTimeout(() => navigate("/dashboard/resumen"), 2000);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background grid-pattern relative overflow-hidden">
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-primary/5 blur-[120px] pointer-events-none" />
      <div className="w-full max-w-md px-6 animate-fade-in">
        <div className="glass rounded-2xl p-8 glow-cyan">
          <div className="flex justify-center mb-8">
            <img src={LOGO_URL} alt="KargoNode" className="h-10 object-contain" />
          </div>
          <h2 className="text-lg font-semibold text-foreground text-center mb-1">Nueva Contraseña</h2>
          <p className="text-sm text-muted-foreground text-center mb-8">Ingresa tu nueva contraseña</p>

          {ready ? (
            <form onSubmit={handleReset} className="space-y-5">
              <div className="space-y-2">
                <label className="text-sm font-medium text-muted-foreground">Contraseña</label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                  <Input
                    type="password"
                    placeholder="Mínimo 6 caracteres"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="pl-10 bg-muted/50 border-border focus:border-primary focus:ring-primary"
                    required
                    minLength={6}
                  />
                </div>
              </div>
              {error && <p className="text-sm text-destructive text-center">{error}</p>}
              {message && <p className="text-sm text-primary text-center">{message}</p>}
              <Button type="submit" disabled={loading} className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-semibold glow-cyan-strong">
                {loading ? "Actualizando..." : "Actualizar Contraseña"}
              </Button>
            </form>
          ) : (
            <p className="text-sm text-destructive text-center">{error}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
